// MapComponent.tsx
import React, { useEffect, useRef, useState } from 'react';
import { MapContainer, TileLayer, FeatureGroup, Polygon as PolygonComponent, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import { EditControl } from 'react-leaflet-draw';
import { LatLngExpression, Polygon } from 'leaflet';
import { Box, Grid, Typography } from '@mui/material';
import { LoaderComponent, SingleButton } from '@/shared/components/ui';
import { useUiStore } from '@/store/ui';
import { AlertSeverityEnum } from '@/shared/interfaces';
import PolygonLayer from '@/shared/components/ui/PolygonLayer/PolygonLayer';
import { useAsignarZonaFlota } from '@/erp/mantenimiento-operacion/flotas';


const ChangeMapView: React.FC<{ center: [number, number] }> = ({ center }) => {
  const map = useMap();

  React.useEffect(() => {
    if (map) {
      map.setView(center, map.getZoom());
    }
  }, [center, map]);

  return null;
};

const polygonStyle = {
  color: 'blue',
  weight: 2,
  opacity: 0.65,
  fillColor: 'blue',
  fillOpacity: 0.4,
};

interface CustomMapZoneCreateProps {
  polygon: LatLngExpression[] | null;
  setPolygon: React.Dispatch<React.SetStateAction<LatLngExpression[] | null>>
  center: [number, number];
  codigo_zona?: string;
}
const CustomMapZoneCreate: React.FC<CustomMapZoneCreateProps> = ({ polygon, setPolygon,
  center,
  codigo_zona
}) => {

  const setAlert = useUiStore(s => s.setAlert);
  const featureGroupRef = useRef<any>(null);
  const { zones: zonesPagingRes, getZone, isLoadingZone } = useAsignarZonaFlota()

  //const [polygon, setPolygon] = useState<LatLngExpression[] | null>(null);
  const [polygonTemp, setPolygonTemp] = useState<LatLngExpression[] | null>(null);
  const [drawingEnabled, setDrawingEnabled] = useState<boolean>(false);

  const handleCreated = (e: L.LeafletEvent & { layer: L.Layer }) => {
    if (e.layer instanceof Polygon) {
      setPolygon(value => {
        if (value) {
          setAlert(true, 'Solo se puede crear un polígono. Elimine el polígono existente para crear uno nuevo.', AlertSeverityEnum.info);
          featureGroupRef.current?.removeLayer(e.layer);
          return value
        }
        e.layer.setStyle(polygonStyle);
        const coords = e.layer.getLatLngs().at(0) as LatLngExpression[];
        return coords;
      })
    }
  };

  const handleDeleted = () => {
    console.log('handleDeleted');
    if (featureGroupRef.current) {
      featureGroupRef.current.clearLayers();
    }
    setPolygon(null)
  };

  const handleEdited = (e: any) => {
    const layers = e.layers;
    layers.eachLayer((layer: any) => {
      const coords = layer.getLatLngs().at(0) as LatLngExpression[];
      setPolygon(coords);
    });
  };

  useEffect(() => {
    if (drawingEnabled) {
      getZone({ page_size: 100 })
    }
  }, [drawingEnabled])


  if (isLoadingZone) return <LoaderComponent />

  return (
    <Grid container item xs={12} spacing={2} justifyContent={'space-between'}  >
      <Grid item>
        <SingleButton
          onClick={() => {
            setDrawingEnabled((value) => {

              if (value && polygon == null) {
                setAlert(true, 'Asignar una zona', AlertSeverityEnum.info);
                return value;
              }

              if (!value) {
                setPolygonTemp(polygon)
                setPolygon(null)
              }
              return !drawingEnabled
            })

          }}
          colorSx='white'
          backgroundSx='black'
          showIcon={true}
          label={drawingEnabled ? 'Guardar Polígono' : 'Trazar Polígono'}
        />
      </Grid>


      {drawingEnabled && (
        <Grid item>
          <SingleButton
            onClick={() => {
              setDrawingEnabled(false);
              setPolygon(polygonTemp)
            }}
            colorSx='white'
            backgroundSx='black'
            showIcon={true}
            label='Cancelar'
          />
        </Grid>
      )
      }



      <Grid item xs={12}>
        <MapContainer
          center={[0, 0]}
          zoom={11}
          style={{ height: '60vh', width: '100%' }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          {
            polygon && !drawingEnabled && (<PolygonComponent positions={polygon}
              color='blue'
              weight={2}
              opacity={0.65}
              fillColor='blue'
              fillOpacity={0.4}
            />)
          }

          {
            drawingEnabled && (
              <PolygonLayer
                isLeafletPopup={false}
                color='green'
                zones={zonesPagingRes.filter(e => e.codigo != codigo_zona) ?? []}
                handleClick={(polygon) => {
                  console.log(polygon);
                }}
              />
            )
          }
          {drawingEnabled && (
            <FeatureGroup
              ref={featureGroupRef}
            >
              <EditControl
                position="topright"
                onCreated={handleCreated}
                onDeleted={handleDeleted}
                onEdited={handleEdited}
                draw={{
                  polyline: false,
                  polygon: true,
                  circle: false,
                  circlemarker: false,
                  rectangle: false,
                  marker: false,
                }}
              />
            </FeatureGroup>
          )}

          <ChangeMapView center={center} />
        </MapContainer>
      </Grid>
      <Grid item xs={6}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{
            width: '40%',
            height: '5px',
            backgroundColor: 'green',
            margin: '0px 10px'
          }}></Box>
          <Typography variant='subtitle2' style={{
            color: '#6C737F',
          }}>
            Otras Zonas
          </Typography>
        </div>
      </Grid>

      <Grid item xs={6}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{
            width: '40%',
            height: '5px',
            backgroundColor: 'blue',
            margin: '0px 10px'
          }}></Box>
          <Typography variant='subtitle2' style={{
            color: '#6C737F',
          }}>
            Zona Asignada
          </Typography>
        </div>
      </Grid>

    </Grid>
  );
};

export default CustomMapZoneCreate;
